import React, { useEffect, useState } from 'react'
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useSelector } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import Container from 'react-bootstrap/Container';
import Link from '../Link';
import messages from '../../locale/messages';
import history from '../../history';
import dashboardNavIcon from '/public/dashboard/dashboardNavIcon.svg'
import bookingNavIcon from '/public/dashboard/bookingNavIcon.svg';
import projectsNavIcon from '/public/dashboard/projectsNavIcon.svg';
import paymentNavIcon from '/public/dashboard/paymentNavIcon.svg';
import profileNavIcon from '/public/dashboard/profileNavIcon.svg';
import s from "./SubNavBar.css"

function SubnavBar() {
    const [location, setLocation] = useState('');
    // LARGE PROJECTS FLAG: hide the "My Projects" (large-projects) tab when the LP
    // module is OFF. Mirrors Footer.js — SSR-seeded runtime store, fail-closed.
    const largeProjectsEnabled = useSelector((state) => state?.runtime?.largeProjectsEnabled);

    useEffect(() => {
        if (history.location) {
            setLocation(history.location.pathname);
        }
    });

    return (
        <div className={cx(s.subNavBarContainer, 'hidden-print')}>
            <Container>
                <ul className={s.subNavBarList}>
                    <li>
                        <Link to="/dashboard" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/dashboard/' || location === '/dashboard') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={dashboardNavIcon} alt="Dashboard Icon" />
                            </div>
                            <FormattedMessage {...messages.dashboard} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/bookings/upcoming" className={cx(s.subNavBarItem, 'subNavBarItemRtl', {
                            [s.active]: location === '/bookings/upcoming' || location === '/bookings/previous' ||
                                location.startsWith('/booking/') || location.startsWith('/tracking/') || location.startsWith('/chat-message/') || location.startsWith('/order/')
                        })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={bookingNavIcon} alt="Booking Icon" />
                            </div>
                            <FormattedMessage {...messages.navBookings} />
                        </Link>
                    </li>
                    {largeProjectsEnabled && (
                    <li>
                        <Link to="/my-projects" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/my-projects' || location === '/my-projects/' || location === '/post-a-project' || location === '/post-a-project/') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={projectsNavIcon} alt="My Projects Icon" />
                            </div>
                            <FormattedMessage {...messages.myProjects} />
                        </Link>
                    </li>
                    )}
                    <li>
                        <Link to="/payment-method" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: ['/payment-method', '/payment-method/', '/add-wallet', '/add-card', '/add-wallet/', '/add-card/'].includes(location) })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={paymentNavIcon} alt="Payment Icon" />
                            </div>
                            <FormattedMessage {...messages.navPayment} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/saved-addresses" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/saved-addresses' || location === '/saved-addresses/') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={profileNavIcon} alt="Saved Addresses Icon" />
                            </div>
                            <FormattedMessage {...messages.navAddresses} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/profile" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/profile' || location === '/profile/') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={profileNavIcon} alt="Profile Icon" />
                            </div>
                            <FormattedMessage {...messages.profile} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/notifications" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/notifications' || location === '/notifications/') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={profileNavIcon} alt="Notifications Icon" />
                            </div>
                            <FormattedMessage {...messages.notifications} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/trusted-contacts" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/trusted-contacts' || location === '/trusted-contacts/') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={profileNavIcon} alt="Trusted Contacts Icon" />
                            </div>
                            <FormattedMessage {...messages.navContacts} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/settings" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/settings' || location === '/settings/') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={profileNavIcon} alt="Settings Icon" />
                            </div>
                            <FormattedMessage {...messages.settings} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/support" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/support' || location === '/support/') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={profileNavIcon} alt="Support Icon" />
                            </div>
                            <FormattedMessage {...messages.support} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/delete-account" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/delete-account' || location === '/delete-account/') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={profileNavIcon} alt="Delete Account Icon" />
                            </div>
                            <FormattedMessage {...messages.navDelete} />
                        </Link>
                    </li>
                </ul>
            </Container>
        </div>
    );
}


export default injectIntl(withStyles(s)(SubnavBar));
